import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { ICamiseta } from "interfaces/kitsCamiseta";
import { KITS_ACCENT } from "../kits-evento.theme";

interface ButtonPlusProps {
  openModalAddEdit: (kit: ICamiseta | null) => void;
}

export default function ButtonPlus({ openModalAddEdit }: ButtonPlusProps) {
  return (
    <Tooltip title="Adicionar novo tamanho do kit">
      <Button
        onClick={() => openModalAddEdit(null)}
        variant="outlined"
        sx={{
          borderStyle: "dashed",
          borderColor: "grey.400",
          width: 108,
          height: 108,
          borderRadius: 2,
          color: KITS_ACCENT,
          "&:hover": {
            borderColor: KITS_ACCENT,
            bgcolor: "rgba(249, 96, 48, 0.04)",
          },
        }}
      >
        <AddIcon fontSize="large" />
      </Button>
    </Tooltip>
  );
}
